import { s as setupPatternlibRuntime } from './runtime-89004cbb.js';

setupPatternlibRuntime();
